var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-container"},[_c('StudentHeaderModule'),_c('div',{staticClass:"student-wrapper"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }